module.exports = __webpack_public_path__ + "img/facebook.d1c7f3bd.svg";